<template>
  <div class="text_table" v-if="!load">

    <Table 
      v-if = "!data_null"
      :data = "table_data"
      :headers = "table_headers"
      :params = "parameters"
      @update="update"
    />

    <div v-else style="height: 100%">
      <h1 style="text-align: center" >
        {{translate('no_data')}}
      </h1>
    </div>
  </div>

  <div v-else style="height: 100%" >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>

<script>
import Table from './Table'

export default {
  name: 'TextTable',
  props: ['all_data', 'params'],
  components: {
    Table
  },
  data () {
    return {
      load: true,
    }
  },
  computed:{
    parameters(){
      if (this.params) {
        return this.params
      }
      return {}
    },
    table_data(){
      return this.all_data.table_data
    },
    table_headers(){
      return this.all_data.table_headers
    },
    data_null(){
      return (this.table_data.length === 0 && this.table_headers.length > 0);
    }
  },

  created(){
    this.init()
  },

  methods: {
    init(){
      let timer = setInterval(() => {
        if (this.table_headers && this.table_headers.length > 0) {
          this.load = false
          clearInterval(timer)
        }
      }, 10)
    },
    update(){
      this.$emit('update')
    }
  }
}

</script>